import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'w-boolean-field',
  templateUrl: './boolean-field.component.html',
  styleUrls: ['./boolean-field.component.scss']
})
export class BooleanFieldComponent implements OnInit {
  @Input() value: boolean;
  @Input() label: string;
  @Input() hideLabel: boolean = false;
  @Input() textLabels: string[] = ['Yes', 'No'];
  @Output() valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(private loggingService: LoggerService) {
  }

  ngOnInit(): void {
  }

  toggle() {
    this.value = !this.value;
    this.valueChange.emit(this.value);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.BooleanFieldComponent, 'Pressed boolean button ' + '<' + this.label + '> .' );
  }
}
